import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";

export default function AcceptableUse() {
  return (
    <LegalLayout title="Acceptable Use Policy" eyebrow="Legal · AUP" lastUpdated="1 March 2026" version="1.0">
      <p>
        This Acceptable Use Policy ("<strong>AUP</strong>") applies to every user of the Connexis platform — buyers,
        publishers, affiliates and visitors. By accessing the platform you agree not to engage in any of the
        prohibited activities below.
      </p>

      <h2>Prohibited activities</h2>
      <ul>
        <li>Submitting, soliciting or storing any consumer enquiry without explicit, recorded consent.</li>
        <li>Reselling, syndicating or otherwise sharing Lead data with any third party other than as expressly permitted in your role's Terms of Service.</li>
        <li>Generating leads through bots, scrapers, co-registration, incentivised traffic or misleading creatives.</li>
        <li>Bidding on the Connexis brand name in paid-search advertising.</li>
        <li>Using the platform to send unsolicited marketing communications in breach of UK GDPR or PECR.</li>
        <li>Attempting to gain unauthorised access to any account, system or data.</li>
        <li>Reverse engineering, decompiling, or otherwise attempting to derive the source code of the platform.</li>
        <li>Probing for vulnerabilities except as part of an authorised responsible-disclosure programme.</li>
        <li>Using the platform in a way that interferes with its operation or another user's enjoyment of it.</li>
        <li>Any use in breach of applicable financial-services regulation (FCA CONC, ICOBS, MCOB), TCPA or equivalent.</li>
      </ul>

      <h2>Enforcement</h2>
      <p>
        Suspected violations may result in immediate suspension of access pending investigation, account
        termination, forfeit of accrued earnings (where Publisher/Affiliate), and where appropriate, reporting to law
        enforcement or the relevant regulator.
      </p>

      <h2>Reporting</h2>
      <p>
        Report violations to <a href="mailto:legal@connex.is">legal@connex.is</a>. Security vulnerabilities may be
        disclosed responsibly to <a href="mailto:legal@connex.is">legal@connex.is</a>.
      </p>
    </LegalLayout>
  );
}
